const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-sign-up'] = {
        c: () => require('partner/modules/dobbies-sign-up/dobbies-sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-sign-up'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-sign-up|dobbies-sign-up'] = {
                c: () => require('partner/modules/dobbies-sign-up/dobbies-sign-up.view.tsx'),
                cn: '__local__-__local__-dobbies-sign-up'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };